const BottomArc = () => {
  return (
    <div
      style={{ backgroundColor: '#000000' }}
      className="flex flex-col h-full items-center overflow-y-auto overflow-x-hidden"
    >
      <div className="bg-transparent px-24 pt-16" />
      <div style={{ backgroundColor: '#000000' }} className="flex-1 w-[150%] px-[25%] mt-64">
        <svg
          width="100%"
          height="300"
          viewBox="0 0 100 100"
          preserveAspectRatio="none"
          className="-mt-[322px]"
          style={{ transform: 'scaleY(-1)' }}
        >
          <path d="M0,100 Q50,0 100,100 Z" fill="#FFFFFF" />
        </svg>
      </div>
    </div>
  )
}

export default BottomArc
